import { AuthContext } from '@providers/AuthProvider'
import { ModuleIdEnum } from 'cs.node.utils/csapi/provisioning'
import { UserRoleEnum } from 'cs.node.utils/RoleUtils'
import { useContext } from 'react'
import styles from './css/SideMenuSection.module.scss'

type Props = {
    name: string
    modules?: (keyof typeof ModuleIdEnum)[]
    roles?: (keyof typeof UserRoleEnum)[]
}

const SideMenuSection = (props:Props) =>{
    const auth = useContext(AuthContext)
    const { name, modules, roles } = props

    // check if the user has access to at least one of the modules listed in the modules property
    const modulesNotAllowed = modules && !auth.userData.modules?.find(module=>{
        return module._id && modules.includes(module._id) && module.enabled
    })

    // check if the user has the role needed for this page
    const roleNotAllowed = !roles || !roles.includes(auth.userData.role)

    if(modulesNotAllowed || roleNotAllowed) return <></>

    return <>
        <div className={styles.container}>
            <div className={`${styles.element} d-flex flex-stack text-gray-700 text-uppercase fs-7`}>
                <span style={{paddingLeft: '2rem'}}>
                    {name}
                </span>
            </div>
        </div>
        <div className="mx-5 mt-2 mb-2 border-bottom"></div>
    </>
}

export default SideMenuSection